<section class="root" aria-labelledby="contact-title">
  <div class="contact-layout">
    <article class="contact-panel" aria-labelledby="contact-title">
      <p class="eyebrow">{{ 'contact.eyebrow' | translate }}</p>
      <h1 id="contact-title">{{ 'common.contactFull' | translate }}</h1>
      <p class="intro">{{ 'contact.intro' | translate }}</p>

      <address class="contact-details" [attr.aria-label]="'contact.detailsLabel' | translate">
        @for (item of contactContent; track item.link) {
          <a class="contact-detail" [href]="item.link" [target]="item.newTab ? '_blank' : ''" rel="noopener noreferrer">
            <img [src]="item.icon" alt="" />
            <span>{{ item.translationKey ? (item.translationKey | translate) : item.label }}</span>
          </a>
        }
      </address>

      <a
        class="whatsapp-button"
        [href]="whatsappLink"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="'contact.whatsappAria' | translate"
      >
        <i class="pi pi-whatsapp" aria-hidden="true"></i>{{ 'contact.whatsapp' | translate }}</a>

      <section class="social-links" aria-labelledby="social-title">
        <h2 id="social-title">{{ 'common.follow' | translate }}</h2>

        <div class="social-list">
          @for (item of socialContent; track item.link) {
            <a [href]="item.link" target="_blank" rel="noopener noreferrer">
              <img [src]="item.icon" [alt]="item.label" /><span>{{
                item.label
              }}</span>
            </a>
          }
        </div>
      </section>
    </article>

    <article class="map-panel" aria-labelledby="location-title">
      <p class="eyebrow">{{ 'contact.locationLabel' | translate }}</p>
      <h2 id="location-title">{{ 'contact.locationTitle' | translate }}</h2>
      @defer (on idle) {
        <app-google-maps></app-google-maps>
      } @placeholder {
        <p class="map-loading" role="status">{{ 'contact.mapLoading' | translate }}</p>
      }
    </article>

    <figure class="image-panel">
      <img
        sohImage="/assets/picaroo/contact_1067x1600.webp" sizes="(max-width: 900px) 92vw, 33vw"
        [alt]="'contact.photoAlt' | translate"
      />
      <figcaption class="image-caption">
        <span class="quote-mark" aria-hidden="true">“</span>
        <p>{{ 'contact.quote' | translate }}</p>
        <i class="pi pi-heart" aria-hidden="true"></i>
      </figcaption>
    </figure>
  </div>
<section class="editorial-page flow-section" id="rezervare" aria-labelledby="booking-title">
<h2 id="booking-title">{{ 'contact.bookingTitle' | translate }}</h2>
<ol><li>{{ 'contact.bookingStep1' | translate }}</li><li>{{ 'contact.bookingStep2' | translate }}</li><li>{{ 'contact.bookingStep3' | translate }}</li></ol>
<p>{{ 'contact.bookingNote' | translate }}</p>
<p><a [href]="whatsappLink" target="_blank" rel="noopener noreferrer">{{ 'contact.availabilityLink' | translate }}</a> · <a [routerLink]="language.path('about')">{{ 'contact.facilitiesLink' | translate }}</a></p>
<h2 id="indicatii">{{ 'contact.directionsTitle' | translate }}</h2><p>{{ 'contact.directions' | translate }}</p>
<p>{{ 'contact.parking' | translate }}</p>
<p><a [href]="GOOGLE_MAPS_LOCATION" target="_blank" rel="noopener noreferrer">{{ 'contact.routeLink' | translate }}</a> · <a [routerLink]="language.path('surroundings')">{{ 'contact.guideLink' | translate }}</a></p></section></section>
